module.exports = __webpack_public_path__ + "public/img/住1.0ee62b32.jpg";